module.exports = __webpack_public_path__ + "static/media/agriculture.2a7c1e92.jpg";